import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ObjectType } from 'typescript';
import { useUser } from '../auth/UseUser';
import Avatar from '@mui/material/Avatar';
import { FaUserAlt } from 'react-icons/fa';

function NavBar() {
  const location = useLocation();

  const { user, setUser } = useUser();
  let navigate = useNavigate();
  const [loc, setLoc] = useState('/inventory');
  useEffect(() => {
    const pathList = location.pathname.split('/');
    setLoc('/' + pathList[1]);
  }, [location.pathname]);

  const logout = () => {
    localStorage.clear();
    setUser({});
  };

  const navList = [{ name: 'Inventory', route: '/inventory' }];
  return (
    <div className="w-full bg-[#0a1929]">
      <div className="w-full h-[70px] flex justify-between items-center p-1 px-8 bg-[#09090d] text-white rounded-b-lg border-b border-[#81848f3d]">
        <p>Hi, {user?.firstName}!</p>

        <div className="flex items-center w-[150px] justify-end gap-6">
          {navList.map((nav) => {
            return (
              <p
                className={`hover:text-yellow-400 cursor-pointer ${
                  loc === nav?.route ? 'text-yellow-400 ' : ''
                }`}
                onClick={() => navigate(nav?.route)}
                key={nav?.name}
              >
                {nav?.name}
              </p>
            );
          })}
          <p
            onClick={logout}
            className="hover:text-yellow-400 cursor-pointer text-right"
          >
            Logout
          </p>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
